import React, { useEffect, useState } from "react";
import { Divider, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { a11yProps, TabPanel } from "../../../utils/cssStyles";
import { MENU_OPEN, SET_BREADCRUMBS } from "../../../redux/actions/actions";
// import SmsRateCardlList from "./sms-rate-cards-list";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import UserList from "./parentUser/user-list";
import ApproveUserList from "./parentUser/approve-user-list";
import ApprovePendingChildUserList from "./childUser/approve-child-user-list";
// import RewardRateCardlList from "./reward-rate-cards-list";

function UserManagement({ role }: { role: number }) {
  const theme: any = useTheme();
  const { state } = useLocation();
  const [paginationModel, setPaginationModel] = useState(state?.paginationModel);
  const [search, setSearch] = useState(state?.search);

  const [value, setValue] = useState(state?.value || 0);

  const path = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const id = path?.pathname;
    dispatch({ type: MENU_OPEN, id });
    dispatch({
      type: SET_BREADCRUMBS,
      payload: [
        { name: "Home", path: "/Dashboard", bold: true },
        { name: "Users", path: null, bold: false },
      ],
    });
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setPaginationModel(undefined);
    setSearch(undefined);
  };

  return (
    <Grid container justifyContent={"center"} spacing={1}>
      <Grid item lg={11} md={12} xs={12}>
        <Typography sx={{ ...theme.typography.pageheader }}>
          <ManageAccountsIcon fontSize="medium" />
          User Management
        </Typography>
      </Grid>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="Vertical tabs example">
          <Tab label="Parent Users" {...a11yProps(0)} />
          <Tab label="Pending Parent Users" {...a11yProps(1)} />
          <Tab label="Pending Child Users" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <UserList role={role} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ApproveUserList />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ApprovePendingChildUserList />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default UserManagement;
